import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { GET, APIImpl } from '../api';
import { FaqRequest } from './faqrequest';
import { LanguageConst } from '../../../utils/resources/languageconst';

export class FaqAPI extends APIImpl<FaqRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/faq.json
        return this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH 
        ? "/en/en/ENG/faq_iosformat.json" : "/my/my/BURMESE/faq_iosformat.json";
    }

    getHttpHeaders():string
    {
       let baseHeaders = super.getHttpHeaders();
       let combinedHeaders : any;

       let faqHeader = {
            'Access-Control-Allow-Origin' : '*'
       } as any; 

       combinedHeaders = Object.assign(faqHeader, baseHeaders);
       return combinedHeaders;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/faq/faqapi.tsx